import { Badge, BadgeProps } from '@ui/lib/park/ui/badge';

export const LongShortBadge = ({
  isLong,
  ...p
}: BadgeProps & {
  isLong: boolean;
}) => {
  return (
    <Badge
      variant="leverage"
      p={2}
      size="sm"
      color={isLong ? 'price.priceUp' : 'price.priceDown'}
      bg={isLong ? 'price.priceUpBg' : 'price.priceDownBg'}
      textStyle="text.xxsmall"
      {...p}
      data-cy="LongShortBadge"
      data-cy-value={isLong ? 'Long' : 'Short'}
    >
      {isLong ? 'Long' : 'Short'}
    </Badge>
  );
};
